import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { WalletProvider } from "@/context/WalletContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import SellerDashboard from "@/pages/SellerDashboard";
import Account from "@/pages/Account";
import OrderDetail from "@/pages/OrderDetail";
import Chat from "@/pages/Chat";
import BecomeSeller from "@/pages/BecomeSeller";
import Wishlist from "@/pages/Wishlist";
import Auction from "@/pages/Auction";
import WalletPage from "@/pages/Wallet";
import Referral from "@/pages/Referral";
import StoreProfile from "@/pages/StoreProfile";

import AdminDashboard from "@/pages/AdminDashboard";
import AuctionDetail from "@/pages/AuctionDetail";
import { HelpCenter, RefundPolicy, ContactUs, TermsOfService, PrivacyPolicy } from "@/pages/StaticPages";

function App() {
  return (
    <div className="App font-body min-h-screen bg-[#050505] text-white">
      <BrowserRouter>
        <AuthProvider>
          <WishlistProvider>
            <WalletProvider>
              <CartProvider>
                <Header />
                <main className="min-h-[60vh]">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/browse" element={<Browse />} />
                    <Route path="/product/:id" element={<ProductDetail />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/checkout/success" element={<CheckoutSuccess />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/seller" element={<SellerDashboard />} />
                    <Route path="/become-seller" element={<BecomeSeller />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="/orders/:orderId" element={<OrderDetail />} />
                    <Route path="/chat" element={<Chat />} />
                    <Route path="/wishlist" element={<Wishlist />} />
                    <Route path="/auction" element={<Auction />} />
                    <Route path="/auctions" element={<Auction />} />
                    <Route path="/auctions/:id" element={<AuctionDetail />} />
                    <Route path="/wallet" element={<WalletPage />} />
                    <Route path="/referral" element={<Referral />} />
                    <Route path="/store/:sellerId" element={<StoreProfile />} />

                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/help" element={<HelpCenter />} />
                    <Route path="/refund-policy" element={<RefundPolicy />} />
                    <Route path="/contact" element={<ContactUs />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                  </Routes>
                </main>
                <Footer />
                <Toaster theme="dark" position="bottom-right" />
              </CartProvider>
            </WalletProvider>
          </WishlistProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
